// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vaW5","content":"styles_content__3QB8b"};